const { trackGtm4 } = require('util/functions');

const CLASS_BREADCRUMBS = '.breadcrumbs--link';

module.exports = {
	init() {
		let array = [];

		const breadcrumbs = this.root.querySelectorAll(CLASS_BREADCRUMBS);
		const widgetName = this.root.getAttribute('data-parent');
		const childrens = this.root.querySelectorAll('a,span');

		childrens.forEach((node, i) => {
			array[i] = node.innerText.trim();
		});

		breadcrumbs.forEach((element, i) => {
			element.addEventListener('click', () => {
				const level = i + 1;
				trackGtm4({
					event: 'GA4_event_c_breadcrumb_click',
					widget_name: widgetName,
					breadcrumb_clicked_text: element
						? element.innerText.trim()
						: 'No text',
					breadcrumb_full_text: array.join(' > '),
					breadcrumb_clicked_level: level.toString(),
				});
			});
		});
	},
};
